import { AddProductsToCartResult } from '@spa/lib/graphql/cart/addProductsToCart';
import { AddToCurrentCartFailedError } from '../../carts/CartsState';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { ProductCodeWithQuantityInput } from '@spa/generated/graphql/graphql';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartAddProductsToCartRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly parentActionId: number;
  readonly productCodesWithQuantities: Array<ProductCodeWithQuantityInput>;
}
export const apiCartAddProductsToCartRequestedType = 'api/cart/addProductsToCart--requested';
export const apiCartAddProductsToCartRequested =
  createAction<ApiCartAddProductsToCartRequestedPayload>(apiCartAddProductsToCartRequestedType);
export type ApiCartAddProductsToCartRequestedAction = ReturnType<
  typeof apiCartAddProductsToCartRequested
>;

export interface ApiCartAddProductsToCartSucceededPayload {
  readonly cartId: string | null;
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly result: AddProductsToCartResult;
  readonly sourceCustomOrderType: CustomOrderType;
  readonly targetCustomOrderType: CustomOrderType;
}
export const apiCartAddProductsToCartSucceededType = 'api/cart/addProductsToCart--succeeded';
export const apiCartAddProductsToCartSucceeded = createAction<
  ApiCartAddProductsToCartSucceededPayload,
  typeof apiCartAddProductsToCartSucceededType
>(apiCartAddProductsToCartSucceededType);
export type ApiCartAddProductsToCartSucceededAction = ReturnType<
  typeof apiCartAddProductsToCartSucceeded
>;

export interface ApiCartAddProductsToCartFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
  readonly failedReason: AddToCurrentCartFailedError;
}
export const apiCartAddProductsToCartFailedType = 'api/cart/addProductsToCart--failed';
export const apiCartAddProductsToCartFailed = createAction<
  ApiCartAddProductsToCartFailedPayload,
  typeof apiCartAddProductsToCartFailedType
>(apiCartAddProductsToCartFailedType);
export type ApiCartAddProductsToCartFailedAction = ReturnType<
  typeof apiCartAddProductsToCartFailed
>;
